import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import MainLayout from "../layouts/MainLayout";
import { useSeoRoute } from "../../seo";

function NotFoundPage() {
  useSeoRoute();

  return (
    <MainLayout>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          py: 6,
          px: 2,
        }}
      >
        <Typography variant="h3" component="h1" gutterBottom>
          404
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Page not found
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 480 }}>
          We couldn&apos;t find a page at this address. Check the URL or return to the map home.
        </Typography>
        <Button variant="contained" component={RouterLink} to="/">
          Go to home
        </Button>
      </Box>
    </MainLayout>
  );
}

export default NotFoundPage;
